const initialState = {
  link: null,
};

const searchLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_LINK':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default searchLinkReducer;
